const sendCaptcha = {
  data() {
    return {
      allowCaptcha: api.vars.allowCaptcha,
    };
  },
  methods: {
    async callCaptcha() {
      this.allowCaptcha = api.vars.allowCaptcha
      //console.log("allowCaptcha:",this.allowCaptcha)
      if (this.allowCaptcha) {
        if (this.greReady) {
          try {
            return await grecaptcha.execute(this.captchaSiteKey, { action: this.captchaAction });
          } catch (e) {
            console.warn("invalid captcha");
          }
        }

        return false;
      } else {
          return true
      }
    },
    updateToken(token) {
      this.$emit("tokenUpdated", token);
    }
  },
};
